import { render, staticRenderFns } from "./more.vue?vue&type=template&id=019e0037&scoped=true&"
import script from "./more.vue?vue&type=script&lang=js&"
export * from "./more.vue?vue&type=script&lang=js&"
import style0 from "./more.vue?vue&type=style&index=0&id=019e0037&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019e0037",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('019e0037')) {
      api.createRecord('019e0037', component.options)
    } else {
      api.reload('019e0037', component.options)
    }
    module.hot.accept("./more.vue?vue&type=template&id=019e0037&scoped=true&", function () {
      api.rerender('019e0037', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/partials/case_opening/more.vue"
export default component.exports